import { IBaseEntity, INode } from './base';
import { ITextDAO } from './text';
import { IOrganisationUser } from './user';

export enum ForumTopicStatus {
  DELETED = -1,
  OPEN = 0,
  RESOLVED = 1,
}

export interface IForumTopic extends IBaseEntity {
  name: string;
  textId: number;
  iconId: number;
  color: number;
  courseId: number;
  moduleId: number;
  actionId: number;
  variableInstanceId: number;
  sceneInstanceId: number;
  organisationUser: IOrganisationUser;
}

export interface IForumTopicDAO extends IForumTopic {
  text?: ITextDAO;
  posts: IForumPostDAO[];
}

/**
 * A post is either the comment that opens a thread or a reply to it.
 *
 * `parentPostId` alone cannot say which: it is only ever set on the client for
 * a reply to an existing opening post, so the first reply on a topic that
 * carries its own body (legacy topics, and any topic whose opening post never
 * landed) would otherwise read as the opening comment and hide the original.
 */
export enum ForumPostType {
  COMMENT = 0,
  REPLY = 1,
}

export interface IForumPost extends IBaseEntity {
  type?: ForumPostType;
  parentPostId: number;
  forumTopicId: number;
  nodeId: number;
  name: number;
  textId: number;
  organisationUser: IOrganisationUser;
}

export interface IForumPostDAO extends IForumPost {
  node: INode;
  name: number;
  text: ITextDAO;
  views: IForumPostView[];
  mentions: IForumMention[];
}

export interface IForumPostView extends IBaseEntity {
  postId: number;
  orgUserId: number;
}

export interface IForumMention extends IBaseEntity {
  postId: number;
  orgUserId: number;
}

/** A post is a reply if it says so, or if it hangs off another post. */
export const isReply = (post?: Pick<IForumPost, 'type' | 'parentPostId'> | null) =>
  post?.type === ForumPostType.REPLY || !!post?.parentPostId;
